import createRoute from '@widesk-ui/tools/createRoute';
import OrderModel  from '@models/shop/OrderModel';

export default createRoute.splitView('/entertainments/:entertainmentId/orders', 'shop', 'OrderSplitView', OrderModel.localize('plural'));
